import { Config } from '@shared/configs/config';

export const privateFile = (url: string): string => {
  return Config.PRIVATE_ATTACHMENT + url;
};
